export default {
  name: 'Search',
  props: {
    value: String,
    placeholder: String,
    clear: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onInput() {
      this.$emit('input', this.$refs.searchInput.value)
    },
    clearInput() {
      this.$emit('input', '')
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/search/search.js